<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="case_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/demandcaselist" style="color: rgba(19,20,28,0.6);font-weight: 500;">案例库</a></el-breadcrumb-item>
          <el-breadcrumb-item><a style="color: rgba(19,20,28,0.9);font-weight: 700;">案例详情页</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div  class="case_detail_content">
        <div class="case_detail_content_imgs">
          <el-image
              src="https://fakeimg.pl/250x100/?text=1"
              class="case_detail_content_img_item"
              :preview-src-list="srcList">

          </el-image>
          <video
              class="case_detail_content_img_video"
              :controls="true"
              src="https://cdn.cnbj1.fds.api.mi-img.com/product-images/mi12s-provuejwm/video_1.mp4"
          ></video>
        </div>
        <div class="case_detail_content_info">
          <div class="case_detail_content_info_title">嘉顿面包主视觉设计项目</div>
          <div class="case_detail_content_info_list">
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">项目周期：</span>
              <span class="case_detail_content_info_list_item_value">30天</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">项目金额：</span>
              <span class="case_detail_content_info_list_item_value">50万-100万</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">客户品牌：</span>
              <span class="case_detail_content_info_list_item_value">爱奇艺</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">所属行业：</span>
              <span class="case_detail_content_info_list_item_value">互联网/互联网</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">所属创意类目：</span>
              <span class="case_detail_content_info_list_item_value"> 网站-网站UI设计 / Web-交互设计 / Web-前端开发 / Web-后台设计</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">服务内容：</span>
              <span class="case_detail_content_info_list_item_value">
                1、创意方案&媒介传播方案
                2、真相系列海报
                3、魔性歌曲MV视频
                4、李佳琦直播间互动迷你场景制作
                5、插画长图文</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'DemandCaseDetail',
  components: {
    Mainl
  },
  data: function () {
    return {
      srcList: [
        'https://fakeimg.pl/250x100/?text=1',
        'https://fakeimg.pl/250x100/?text=2'
      ],
      form: {
        name: '',
        money: '',
        category_id: '',
        industry_id: '',
        category_key: ''
      },
      industry_info: [], // 选中的行业数据
      category_info: [], // 选中的创意类目数据
      caseList: [],
      xy_case_money_dict: [], // 项目金额字典
      industry_dic: [], // 所属行业字典
      category_dic: [], // 创意类目字典
      top_creative_categories_dict: [], // 单一级创意类目字典
      caseCount: 0,
      currentPage: 1,
      pageSize: 18, // 每页数量
    }
  },
  created () {
    // 获取字典数据
    this.getDict()
  },
  mounted () {
    this.initList()
  },
  methods: {
    // 获取字典
    getDict () {
      var selfthis = this
      var url = pubPrefix + '/api/case/dict'
      commfun.ajaxGet(selfthis, url, {}, function (selfthis, result) {
        selfthis.xy_case_money_dict = result.xy_case_money_dict
        selfthis.industry_dic = result.industry_dic
        selfthis.category_dic = result.category_dic
        selfthis.top_creative_categories_dict = result.top_creative_categories_dict
      }, function (selfthis, result) {
        selfthis.$message({
          showClose: true,
          message: '字典查询错误，请联系管理员！',
          type: 'warning',
          customClass: 'zZindex'
        })
      })
    },
    // 列表数据
    initList: function () {
      var selfthis = this
      var url = pubPrefix + '/api/case/caseList'
      var postdata={
        category_key: this.form.category_key,
        name:this.form.name,
        money:this.form.money,
        category_id:this.form.category_id,
        industry_id:this.form.industry_id,
        pageSize:this.pageSize,
        currentPage:this.currentPage,
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data == null || data === undefined) {
          selfthis.caseList = []
          selfthis.caseCount = 0
        } else {
          selfthis.caseList = data.data
          selfthis.caseCount = data.count
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 重置筛选条件
    resetList () {
      for(var i in this.form){
        this.form[i]=""
      }
      this.industry_info = []
      this.category_info = []
      this.initList()
    },
    // 行业选择
    industryChange(value){
      if (this.industry_info.length > 0) {
        this.form.industry_id = this.industry_info[1]
      } else {
        this.form.industry_id = ''
      }
    },
    // 创意类目筛选
    categoryChange (value) {
      if (this.category_info.length > 0) {
        this.form.category_id = this.category_info[1]
        this.form.category_key = this.category_info[0]
      } else {
        this.form.category_id = ''
      }
    },
    // 一级创意类目选择
    checkCategoryKey (val) {
      this.form.category_key = val
    },
    // 切换页码
    handlePageChange(currentPage) {
      // 处理页码变化回调，更新 currentPage 并重新获取数据
      this.currentPage = currentPage;
      this.initList();
    },
    // 案例详情
    goDetail (item) {
      window.open('/demandcasedetail?case_id=' + item.case_id)
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DemandCaseDetail.vue